import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Link, Typography } from '@mui/material';

const ToS = () => {
    const {t} = useTranslation();

    return (
        <Container sx={{mt: 4}}>
            <Grid container>
                <Grid xs={1}>
                    <Link href="/register">{t('back')}</Link>
                </Grid>
                <Grid xs={11}>
                    <Typography variant="h5">{t('terms_of_service')}</Typography>

                    <Typography>
                        Tos text will be later
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ToS;
